module.exports = __webpack_public_path__ + "static/crossword-b5c5ab66d8331513696fe3ec992187a0.png";